import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { RunnerState } from '@playground/models/types';

interface Props {
  status: RunnerState;
}

const statusAnimateClasses = (status: string) => {
  return classNames('animate-ping absolute inline-flex h-full w-full rounded-full opacity-75', {
    'bg-platzi-green': status === 'idle',
    'bg-platzi-error': status !== 'idle',
  });
};

const statusItemClasses = (status: string) => {
  return classNames('relative inline-flex rounded-full h-3 w-3', {
    'bg-platzi-green': status === 'idle',
    'bg-platzi-error': status !== 'idle',
  });
};

const Status: FunctionComponent<Props> = ({ status }) => {
  return (
    <span className="flex absolute h-3 w-3 top-5 right-5 -mt-1 -mr-1">
      <span className={statusAnimateClasses(status)}></span>
      <span className={statusItemClasses(status)}></span>
    </span>
  );
};

export default Status;
